export const REPORTING_TIMEZONE = 'Europe/Oslo';

export function osloDay(date = new Date()): string {
  const parts = new Intl.DateTimeFormat('en', {
    timeZone: REPORTING_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);
  const part = (type: Intl.DateTimeFormatPartTypes): string =>
    parts.find((candidate) => candidate.type === type)?.value ?? '';
  return `${part('year')}-${part('month')}-${part('day')}`;
}

export function shiftIsoDay(day: string, amount: number): string {
  const date = new Date(`${day}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + amount);
  return date.toISOString().slice(0, 10);
}

export function completeThroughDay(now = new Date()): string {
  return shiftIsoDay(osloDay(now), -1);
}

/**
 * Order a range without touching its ends. The dashboard's global filter must
 * be able to reach TODAY: only the growth ledger needs whole days, and it
 * clamps itself server-side (resolveCompleteReportingRange) while the scorecard
 * spells out «Valgt periode … Effektiv periode …». Clamping globally took
 * today away from Oversikt, Ads, Kalender, Lønnsomhet, Leads and Verving.
 */
export function orderIsoRange(from: string, to: string): { from: string; to: string } {
  return from > to ? { from: to, to: from } : { from, to };
}

export function clampToCompleteDays(
  from: string,
  to: string,
  now = new Date(),
): {
  from: string;
  to: string;
} {
  let safeFrom = from;
  let safeTo = to;
  if (safeFrom > safeTo) [safeFrom, safeTo] = [safeTo, safeFrom];
  const completeThrough = completeThroughDay(now);
  if (safeTo > completeThrough) safeTo = completeThrough;
  if (safeFrom > completeThrough) safeFrom = completeThrough;
  if (safeFrom > safeTo) safeFrom = safeTo;
  return { from: safeFrom, to: safeTo };
}
